import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tasks-table-header',
  templateUrl: './tasks-table-header.component.html',
  styleUrls: ['./tasks-table-header.component.scss']
})
export class TasksTableHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
